import React from 'react';
import {TextStyle, ViewStyle} from 'react-native';
import {BadgeContainer, BadgeText, Container} from './styles';

interface Badge {
  text?: string;
  containerStyle?: ViewStyle;
  textStyle?: TextStyle;
}

export function Badge({text, containerStyle, textStyle}: Badge) {
  return (
    <Container>
      <BadgeContainer style={containerStyle}>
        <BadgeText style={textStyle}>{text}</BadgeText>
      </BadgeContainer>
    </Container>
  );
}
